let interval = 1000; 
let maxAttempts = 10; 
let attempts = 0;
let intervalId = setInterval(function() {
    attempts++;
    let element = document.querySelector('.cart-item__details .product-option');
    if (element) {
      const option_id = document.querySelectorAll('.cart-item__details .product-option')
        option_id.forEach((item) =>{
        if (item.textContent.includes('customization_id:')) {
                item.remove();
            }
        })
        clearInterval(intervalId);
    } else if (attempts >= maxAttempts) {
        console.log('Element not found within 10 seconds.');
        clearInterval(intervalId);
    }
}, interval);